import React, { Component } from "react";
import { connect } from "react-redux";
import { Switch, Route } from "react-router-dom";

// Components
import AdminReviewsForm from "./AdminReviewsForm";
import AdminReviewsEdit from "./AdminReviewsEdit";

// State
import { addRoute } from "../../../store/actions/route";

class AdminReviews extends Component {
	constructor(props) {
		super(props);
		this.props.addRoute(this.props.match);
	}

	// ===================================================================================
	//  RENDER
	// ===================================================================================
	render() {
		return (
			<Switch>
				<Route path={"/admin/reviews/add"} exact component={AdminReviewsForm} />
				<Route path={"/admin/reviews/edit"} component={AdminReviewsEdit} />
				<Route path={"/admin/reviews"} component={AdminReviewsEdit} />
			</Switch>
		);
	}
}

export default connect(
	null,
	{ addRoute }
)(AdminReviews);



// WEBPACK FOOTER //
// ./src/components/admin/reviews/AdminReviews.js